import React from 'react'
import { RefreshCw, AlertTriangle } from 'lucide-react'
import { Button, Card } from '../ui'

const SyncLockoutModal = ({ isOpen = false, onRefresh }) => {
  if (!isOpen) {
    return null
  }

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/70 px-4 backdrop-blur-sm">
      <Card
        className="room-elevated room-glow w-full max-w-sm border p-6 text-[var(--room-text)] shadow-2xl"
        role="alertdialog"
        aria-labelledby="sync-lockout-title"
        aria-describedby="sync-lockout-description"
      >
        <div className="mx-auto mb-4 flex h-11 w-11 items-center justify-center rounded-full bg-red-500/15 text-red-400">
          <AlertTriangle className="h-5 w-5" />
        </div>

        <h2 id="sync-lockout-title" className="text-center text-lg font-semibold">
          Connection recovery timed out
        </h2>
        <p
          id="sync-lockout-description"
          className="mt-2 text-center text-sm text-[var(--room-muted)]"
        >
          We could not restore realtime sync for this room. Refresh to rejoin and recover authoritative playback and queue state.
        </p>

        <Button
          type="button"
          className="room-focus-ring mt-5 h-11 w-full rounded-xl border border-[color:var(--room-primary)] bg-[color:rgba(46,168,255,0.22)] text-[var(--room-text)] hover:bg-[color:rgba(46,168,255,0.3)]"
          onClick={onRefresh}
          aria-label="Refresh room after sync lockout"
        >
          <RefreshCw className="h-4 w-4" />
          Refresh Room
        </Button>
      </Card>
    </div>
  )
}

export default SyncLockoutModal
